import algoliasearch from 'algoliasearch'
import insightsClient from 'search-insights'

const projectId = process.env.NEXT_PUBLIC_ALGOLIA_PROJECT_ID as string
const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY as string
const algoliaQuoteIndex = process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' ? 'dev_QUOTES' : 'prod_QUOTES'
const algoliaCCSSProductIndex =
	process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' ? 'dev_CCSS_PRODUCTS' : 'prod_CCSS_PRODUCTS'
const algoliaTEKSProductIndex =
	process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' ? 'dev_TEKS_PRODUCTS' : 'prod_TEKS_PRODUCTS'
const algoliaBookIndex = process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' ? 'dev_BOOKS' : 'prod_BOOKS'
const algoliaLADOEUnit = process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' ? 'dev_LADOE_UNITS' : 'prod_LADOE_UNITS'

insightsClient('init', { appId: projectId, apiKey, useCookie: true })

export const algolia = algoliasearch(projectId, apiKey)
export const quoteIndex = algolia.initIndex(algoliaQuoteIndex)
export const ccssProductIndex = algolia.initIndex(algoliaCCSSProductIndex)
export const teksProductIndex = algolia.initIndex(algoliaTEKSProductIndex)
export const bookIndex = algolia.initIndex(algoliaBookIndex)
export const ladoeUnitIndex = algolia.initIndex(algoliaLADOEUnit)

export const insights = insightsClient
